import { useEffect, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useLiveEvents } from "./useLiveEvents";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = () => { const t = localStorage.getItem("sigmacare_token"); return { withCredentials: true, headers: t ? { Authorization: `Bearer ${t}` } : {} }; };

/** Live permission propagation: SSE `access.changed` (targeted at this user) triggers onChange; a 60s poll of
 *  /rbac/me permission_version is the fallback when SSE is disconnected. A 401 means the session was revoked → onRevoked. */
export function useAccessLive(onChange, { enabled = true, onRevoked } = {}) {
  const cb = useRef(onChange); cb.current = onChange; const ver = useRef(null);
  useLiveEvents(["access.changed"], (topic, data) => { if (topic === "access.changed") { toast.info("Your access permissions were updated"); cb.current(data || {}); } }, enabled);
  useEffect(() => {
    if (!enabled) return undefined;
    const check = async () => {
      try {
        const r = await axios.get(`${API}/rbac/me`, cfg()); const v = r.data.permission_version ?? 0;
        if (ver.current !== null && v !== ver.current) cb.current({ reason: "poll" });
        ver.current = v;
      } catch (e) { if (e?.response?.status === 401 && onRevoked) onRevoked(); }
    };
    check(); const t = setInterval(check, 60000);
    return () => clearInterval(t);
  }, [enabled]); // eslint-disable-line react-hooks/exhaustive-deps
}
